<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-btn">
                <el-button @click="add_isShow = !add_isShow">添加</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                <div class="text-status">
                    <span>开启状态：</span>
                    <el-switch v-model="on" active-value="1" inactive-value="0" @change="statusChange"> </el-switch>
                </div>
            </div>
        </div>
        <el-table :data="tableData" class="table" header-cell-class-name="table-header">
            <el-table-column prop="id" label="id"></el-table-column>
            <el-table-column prop="amount" label="金额（元）"></el-table-column>
            <el-table-column prop="city_amount" label="公司收取（元）"></el-table-column>
            <el-table-column prop="driver_amount" label="司机收取（元）"></el-table-column>
            <el-table-column prop="time.YmdHis" label="创建时间"></el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button type="primary" @click="delDynamicMarkupSubmit(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="Number(result_data)"
            >
            </el-pagination>
        </div>
        <!-- 添加组件 -->
        <addDynamicMarkup :isShow="add_isShow" @onSubmit="dynamicMarkupLists"></addDynamicMarkup>
    </div>
</template>
<script>
var _this;
import addDynamicMarkup from './addDynamicMarkup.vue';
export default {
    components: {
        addDynamicMarkup
    },
    data() {
        return {
            add_isShow: false,
            tableData: [],
            result_data: '',
            on: '',
            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10
            },
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.dynamicMarkupLists();
    },
    methods: {
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            console.log(val, 'val页码变化');
            _this.search_data.page = val;
            console.log(_this.search_data.page, '_this.search_data.page');
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            console.log('翻页组件回调');
            //初始化列表
            _this.dynamicMarkupLists();
        },
        searchDynamicMarkupLists() {
            _this.search_data.page = 1;
            _this.dynamicMarkupLists();
        },
        dynamicMarkupLists() {
            _this
                .$post('/dynamicmarkup/dynamicMarkupLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data.result;
                    _this.result_data = res.data.count;
                    
                    _this.on = res.data.on;
                })
                .catch((err) => {});
        },

        statusChange() {
            console.log(112233);
            _this
                .$post('/dynamicmarkup/editDynamicMarkupConfSubmit', {
                    open: _this.on
                })
                .then((res) => {});
        },
        delDynamicMarkupSubmit(val) {
            if(_this.on == '1'){
                this.$message.error("启用状态下不可删除");
                return;
            }
            console.log(val);
            _this
                .$post('/dynamicmarkup/delDynamicMarkupSubmit', {
                    order_dynamic_markup_code: val.order_dynamic_markup_code,
                    
                })
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.dynamicMarkupLists();
                })
                .catch((err) => {});
        },
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>
<style scoped>
.handle-btn {
    display: flex;
    align-items: center;
}
.text-status {
    margin-left: 10px;
    display: inline-block;
}
</style>